export default "__VITE_ASSET__DCQo7fCd__"